import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 350px;
`;

export const Title = styled.div`
  color: #333333;
  font-size: 24px;
  font-weight: 500;
  margin: 16px 0;
  text-align: center;
`;

export const Detail = styled.div`
  background-color: #f0f3f6;
  border-radius: 2.5px;
  color: #4f4f4f;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 8px 12px;
  width: 100%;
  &.last-child {
    margin-bottom: 24px;
  }
`;

export const StyledButton = styled(Button)`
  box-shadow: none;
  color: white;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  &.secondary {
    color: #333;
  }
`;

export const SelectWrapper = styled.div<{ selected?: boolean }>`
  margin-bottom: 24px;
  position: relative;
  width: 100%;

  select {
    appearance: none;
    background-color: #ffffff;
    border: 1px solid #bdbdbd;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    padding: 8px 24px 8px 12px;
    width: 100%;

    &.hidden {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
    }

    ${({ selected }) => (selected ? 'color: #333333;' : 'color: #bdbdbd;')}
  }

  .arrow-down-icon {
    height: 34px;
    padding: 10px;
    pointer-events: none;
    position: absolute;
    right: 0px;
    width: 34px;
  }
`;
